import React from 'react'
import PropTypes from 'prop-types'

const money = value =>
  value == null ? 'Unknown' : `£${(value / 100).toFixed(2)}`

export default function DeliveryFeeComparison({ comparison }) {
  if (!comparison || comparison.status === 'legacy') return null
  return (
    <div role='note' style={{ gridColumn: '1 / -1', margin: '8px 0' }}>
      <strong>Delivery (ex VAT)</strong>
      <div>
        Expected: {money(comparison.expectedNetPennies)} · Invoice:{' '}
        {money(comparison.invoicedNetPennies)}
      </div>
      <div>
        Difference (invoice minus expected):{' '}
        {money(comparison.differencePennies)}
      </div>
      <div>Invoice delivery VAT: {money(comparison.invoicedVatPennies)}</div>
      {comparison.requiresReview && (
        <div>
          Delivery needs review. Check the original invoice and submitted order
          before reconciliation.
        </div>
      )}
    </div>
  )
}
DeliveryFeeComparison.propTypes = { comparison: PropTypes.object }
